import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, reactive, onMounted, unref } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { GbTables } from '@/components/GbTables';
import { useGbTable } from '@/hooks/useGbTable';
import { formatTools } from '@/utils';
import { BillMaterialApi } from '@/apis/PayPlans/payplan.api';

// 添加多语言支持
import { useLocales } from '@/hooks/useLocales';

import PdfViewDialog from '@/views/contracts/editors/components/pdfViewDialog.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const pdfViewRef = ref<InstanceType<typeof PdfViewDialog>>();

const { register, tableObject } = useGbTable();
const { fDateTime } = formatTools();
const { resolve } = useRouter();

// 获取翻译函数
const { t } = useLocales();

const tabColumns = reactive<any[]>([
	{ field: 'file_name', label: t('billMaterialList.table.fileName', '文件名称') },
	{ field: 'material_type_desc', label: t('billMaterialList.table.category', '分类'), columnWidth: '100', align: 'center' },
	{ field: 'file_suffix', label: t('billMaterialList.table.fileType', '文件类型'), columnWidth: '80', headerAlign: 'center', align: 'center' },
	{ field: 'file_size', label: t('billMaterialList.table.fileSize', '文件大小'), columnWidth: '120', headerAlign: 'center', align: 'right' },
	{ field: 'curr_version', label: t('billMaterialList.table.currentVersion', '当前版本'), columnWidth: '80', align: 'center' },
	{ field: 'created_user_id', label: t('billMaterialList.table.uploadUser', '上传用户'), columnWidth: '120', align: 'center' },
	{ field: 'created_time', label: t('billMaterialList.table.uploadTime', '上传时间'), columnWidth: '120', align: 'center' },
	{ field: 'action', width: '80px', label: t('billMaterialList.table.action', '操作'), fixed: 'right', align: 'center' },
]);

const state = reactive({
	load: false,
	materialTypeList: [] as any[],
});

const actions = {
	docEditor: (row: any, tags: string) => {},
	/* 文件预览 */
	preview: (row: any) => {
		/* .pdf文件避免使用OnlyOffice打开，因为pdf文件有可能引发不可预料的错误 */
		if (row.file_suffix != '.pdf') {
			/* 如果是office系文件，则使用onlyoffice打开 */
			const isOfficeFile = ['.doc', '.docx', 'text', '.xls', 'xlsx'].includes(row.file_suffix);
			if (isOfficeFile) {
				let urls = resolve({ path: `/onlyoffices/docview/${row.id}/1` });
				window.open(urls.href, '_blank');
			} else {
				// 图片类型文件后缀
				const isPicFile = ['.jpg', '.gif', '.png', '.jpeg', '.bmp', '.webp'].includes(row.file_suffix);
				if(isPicFile) {
					window.open(row.file_url, '_blank')
				} else {
					// ElMessage.error(t('billMaterialList.message.filePreviewError', '该文件类型无法在线预览'))
					window.open(row.file_url, '_blank')
				}
			}
		} else {
			unref(pdfViewRef)?.openDialog(row);
		}
	},
	previewTitle: (row: any) => {
		const isPreview = ['.pdf','.doc', '.docx', 'text', '.xls', 'xlsx','.jpg', '.gif', '.png', '.jpeg', '.bmp', '.webp'].includes(row.file_suffix);
		return `${isPreview?t('billMaterialList.buttons.preview', '预 览'):t('billMaterialList.buttons.download', '下 载')}`;
	},
	/* 文件删除 */
	deleteFile: (row: any) => {},
};

const methods = {
	/* 获取付款申请关联附件记录 */
	setFileList: async (billID: string) => {
		console.log(billID)
		state.load = true;
		const { succeeded, errors, data } = await BillMaterialApi(billID);
		state.load = false;

		if (!succeeded) {
			ElMessage.error(`读取附件列表出错，可能的原因是：${errors}`);
		} else {
			tableObject.tableList = data || [];
		}
	},
};

expose({ ...methods });
onMounted(() => {});

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(GbTables), {
      data: _unref(tableObject).tableList,
      columns: _unref(tabColumns),
      "show-paged": false,
      onRegister: _unref(register)
    }, {
      created_time: _withCtx(({ row }) => [
        _createTextVNode(_toDisplayString(_unref(fDateTime)(row.created_time)), 1)
      ]),
      material_type_desc: _withCtx(({ row }) => [
        _createVNode(_component_el_tag, {
          size: "small",
          type: "info"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(row.material_type_desc), 1)
          ]),
          _: 2
        }, 1024)
      ]),
      action: _withCtx(({ row }) => [
        _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          link: "",
          onClick: ($event: any) => (actions.preview(row))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(actions.previewTitle(row)), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }, 8, ["data", "columns", "onRegister"]),
    _createVNode(PdfViewDialog, {
      ref_key: "pdfViewRef",
      ref: pdfViewRef
    }, null, 512)
  ], 64))
}
}

})